import { render, staticRenderFns } from "./DettachedCheckin.vue?vue&type=template&id=045c2846&"
import script from "./DettachedCheckin.vue?vue&type=script&lang=js&"
export * from "./DettachedCheckin.vue?vue&type=script&lang=js&"
import style0 from "./DettachedCheckin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports